export class ControlStockModel {

  uid: string;
  description: string;
  quantity: number;

  constructor() { }
}
